import {
  MonthPickerInput as MantineMonthPickerInput,
  MonthPickerInputProps as MantineMonthPickerInputProps
} from "@mantine/dates";

export type MonthPickerInputProps = MantineMonthPickerInputProps

export const MonthPickerInput = (props: MonthPickerInputProps) => {
  return <MantineMonthPickerInput {...props} />;
};
